import { CompanyMetadataContext, CompanyMetadataInit } from "./context";
import { useGetOneOrganization } from "src/api/client-api/company/useGetOneOrganization.ts";
import { Loading } from "src/components/utils/Loading";
import { useGetOneSsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion.ts";
import { useGetSsqVersionAssignment } from "src/api/client-api/questionnaire/useGetSsqVersionAssignment.ts";
import { useFoodpilotContext } from "src/context/FoodpilotContext.tsx";

type CompanyProviderProps = {
    children: ReactNode;
    companyId: number;
    ssqId?: number; // Optional ssqId parameter to override company.organizationSector.ssqId
};
export const CompanyMetadataProvider = (props: CompanyProviderProps) => {
    const { children, companyId, ssqId: urlSsqId } = props;
    const { currentCampaign } = useFoodpilotContext();

    const { company, isReady } = useGetOneOrganization({
        companyId: companyId.toString(),
        withoutRelations: true,
    });

    const ssqId = urlSsqId ?? company?.organizationSector?.ssqId;

    const { ssqVersionAssignment, isReady: isAssignmentReady } = useGetSsqVersionAssignment(ssqId, currentCampaign?.id);

    const ssqVersionId = ssqVersionAssignment?.ssqVersionId;

    const { ssqVersion, isReady: isSsqVersionReady } = useGetOneSsqVersion(ssqVersionId);

    const areAllReady = isReady && isAssignmentReady && isSsqVersionReady;
    if (areAllReady === false) {
        return <Loading />;
    }

    if (company === undefined) {
        // The company GET failed (network error, 4xx, 5xx). Returning the children
        // unwrapped would propagate the failure as a misleading React error
        // ("useCompanyMetadata must be used within the context") inside every
        // descendant. Render a `Loading` state instead — react-query will retry
        // the request and the provider will rehydrate transparently once the
        // backend recovers. If the failure is permanent, the user sees a
        // controlled spinner rather than a crash dump.
        return <Loading />;
    }

    const items: CompanyMetadataInit = {
        company,
        ssqVersion,
        // allSsqs: ssqs ?? [],
    };

    return <CompanyMetadataContext.Provider value={items}>{children}</CompanyMetadataContext.Provider>;
};
